/* Adam's Frisör® — dark homepage atmosphere + bidirectional scroll motion */
(() => {
  'use strict';

  const main = document.querySelector('#MainContent[data-template="index"]');
  if (!main || main.dataset.afsDarkMotionReady === 'true') return;
  main.dataset.afsDarkMotionReady = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealReady = new WeakSet();
  const sceneReady = new WeakSet();
  let scenes = [];
  let frame = 0;
  let lastY = window.scrollY || 0;

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  const revealObserver = !reduceMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-afs-viewport', entry.isIntersecting);
        });
      }, { threshold: 0.12, rootMargin: '-6% 0px -10% 0px' })
    : null;

  const sceneObserver = !reduceMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-afs-scene-visible', entry.isIntersecting);
        });
      }, { threshold: 0.08, rootMargin: '-8% 0px -12% 0px' })
    : null;

  function registerReveals(scope = document) {
    const nodes = [];
    if (scope instanceof Element && scope.matches('.afs-reveal')) nodes.push(scope);
    if (scope.querySelectorAll) nodes.push(...scope.querySelectorAll('.afs-reveal'));

    nodes.forEach((node) => {
      if (revealReady.has(node)) return;
      revealReady.add(node);
      if (!revealObserver) {
        node.classList.add('is-afs-viewport');
        return;
      }
      revealObserver.observe(node);
    });
  }

  function registerScenes() {
    scenes = [...main.querySelectorAll('.afs-home-section, .adam-gallery, .adam-cards, .adam-cta')];
    scenes.forEach((scene, index) => {
      scene.dataset.afsScene = String(index + 1);
      if (sceneReady.has(scene)) return;
      sceneReady.add(scene);
      if (!sceneObserver) {
        scene.classList.add('is-afs-scene-visible');
        return;
      }
      sceneObserver.observe(scene);
    });
  }

  function updateAtmosphere() {
    frame = 0;
    const y = window.scrollY || 0;
    const delta = y - lastY;
    if (Math.abs(delta) > 2) {
      main.dataset.afsScrollDirection = delta > 0 ? 'down' : 'up';
    }
    lastY = y;

    const viewport = window.innerHeight || 1;
    const pageRange = Math.max(document.documentElement.scrollHeight - viewport, 1);
    const pageProgress = clamp(y / pageRange);

    main.style.setProperty('--afs-aura-x', `${18 + pageProgress * 64}%`);
    main.style.setProperty('--afs-aura-y', `${16 + pageProgress * 68}%`);
    main.style.setProperty('--afs-aura-shift', `${(pageProgress - 0.5) * 30}px`);

    scenes.forEach((scene, index) => {
      const rect = scene.getBoundingClientRect();
      const local = clamp((viewport - rect.top) / (viewport + rect.height));
      const alternate = index % 2 === 0;
      const x = alternate ? 78 - local * 22 : 22 + local * 22;
      const sceneY = 18 + local * 64;
      scene.style.setProperty('--afs-scene-x', `${x}%`);
      scene.style.setProperty('--afs-scene-y', `${sceneY}%`);
      scene.style.setProperty('--afs-scene-strength', String(0.58 + Math.sin(local * Math.PI) * 0.28));
    });
  }

  function requestUpdate() {
    if (reduceMotion || frame) return;
    frame = requestAnimationFrame(updateAtmosphere);
  }

  function init(scope = document) {
    registerReveals(scope);
    registerScenes();
    if (reduceMotion) {
      main.dataset.afsScrollDirection = 'down';
      main.style.setProperty('--afs-aura-x', '22%');
      main.style.setProperty('--afs-aura-y', '28%');
      return;
    }
    updateAtmosphere();
  }

  init(document);
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    requestUpdate();
  });
})();
